import React from 'react';
import { Outlet } from 'react-router-dom';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';

import ChatLauncher from 'components/ChatLauncher';
import ErrorBoundary from 'components/ErrorBoundary';
import Header from 'containers/App/Header';
import DemoModeBar from 'containers/DemoModeBar';
import PrivacyModeBar from 'containers/PrivacyModeBar';
import Services from 'containers/Services';
import UserGuide from 'containers/UserGuide';
import { useAppSelector } from 'hooks/redux';

const LayoutDatasetEntitled = () => {
  const demoMode = useAppSelector((store) => featureFlagsSelectors.getFeatureFlag(store, 'demoMode'));
  const [sPrivacyMode] = usePreferenceV2('sPrivacyMode');

  return (
    <Box id='app-router-root' height='100vh' display='flex' flexDirection='column'>
      <Collapse in={Boolean(demoMode)} style={{ minHeight: 'unset' }}>
        <DemoModeBar />
      </Collapse>

      <Collapse in={Boolean(sPrivacyMode)} style={{ minHeight: 'unset' }}>
        <PrivacyModeBar />
      </Collapse>

      <Box position='relative' flexGrow={1} overflow='auto'>
        <Header />
        <Box
          id='feature-root'
          data-testid='feature-root'
          ml={7}
          position='relative'
          display='flex'
          flexDirection='column'
          height='100%'
          overflow='auto'
        >
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>

        <Services />

        <ErrorBoundary>
          <ChatLauncher />
        </ErrorBoundary>

        <ErrorBoundary>
          <UserGuide />
        </ErrorBoundary>
      </Box>
    </Box>
  );
};
export default LayoutDatasetEntitled;
